import { render, staticRenderFns } from "./headSssembly.vue?vue&type=template&id=70ce4660&scoped=true&"
import script from "./headSssembly.vue?vue&type=script&lang=js&"
export * from "./headSssembly.vue?vue&type=script&lang=js&"
import style0 from "./headSssembly.vue?vue&type=style&index=0&id=70ce4660&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ce4660",
  null
  
)

export default component.exports